export default "__VITE_ASSET__c4e5821b__"